export const LOCAL_STORAGE_KEY_DATE_FILTER = 'date-filter'
export const QUERY_KEY_ACTIVE_ADVISERS_NUMBER = 'nr-of-active-advisers'
export const QUERY_KEY_REVIEW_INVITATION_STATS = 'review-invitation-stats'
export const QUERY_KEY_REVIEWS_NUMBER = 'nr-of-reviews'
export const QUERY_KEY_OVERALL_RATING = 'overall-rating'
export const QUERY_KEY_QUALITY_OF_ADVICE_RATING = 'quality-of-advice-rating'
export const QUERY_KEY_QUALITY_OF_SERVICE_RATING = 'quality-of-service-rating'
export const QUERY_KEY_VALUE_FOR_MONEY_RATING = 'value-for-money-rating'
export const QUERY_KEY_NPS_RATING = 'nps-rating'
export const QUERY_KEY_RATINGS = 'ratings_'
export const QUERY_KEY_POTENTIAL_CLIENTS_DATA = 'potential-clients-data'
export const QUERY_KEY_INFLUENCED_AND_RECOMMENDERS_DATA = 'influenced-and-recommenders'
export const QUERY_KEY_TOP_RATED_ADVISERS_COUNT_DATA = 'top-rated-advisers-count'
export const QUERY_KEY_VERIFIED_BY_ADVISER_STATS = 'verified-by-adviser-stats'
export const QUERY_KEY_CONTENT_ADDED_OR_SHARED_STATS = 'content-added-or-shared-stats'
export const QUERY_KEY_PROFESSIONALS_FOR_FILTER = 'professionals-for-filter'
export const QUERY_KEY_QUESTIONS_BREAKDOWN_BY_METRIC = 'questions-breakdown-by-metric'
export const QUERY_KEY_QUESTIONS_BREAKDOWN_ALL = 'questions-breakdown-all'
export const QUERY_KEY_CONSUMER_DUTY_SCORE_DATA = 'consumer-duty-score'
export const QUERY_KEY_RECOMMENDATIONS_PER_CLIENT_DATA = 'recommendations-per-client'
export const QUERY_KEY_OPPORTUNITIES_NUMBER = 'opportunities-number'
export const QUERY_KEY_IDENTITY = 'identity'
export const QUERY_KEY_PROSPECT_CONVERSION = 'prospect-conversion'
export const QUERY_KEY_ELEVATION_AI_SUMMARY = 'elevation-ai-summary'
export const QUERY_KEY_ELEVATION_AI_SUMMARY_ID = 'elevation-ai-summary-id'
export const QUERY_KEY_THUMB_FEEDBACK_RATING = 'thumb-feedback-rating'
export const QUERY_KEY_PRIMARY_SERVICE_TYPE = 'primary-service-type'
export const QUERY_KEY_ELEVATION_BY_ADVISER_SCORES = 'elevation-by-adviser-scores'
export const QUERY_KEY_PERFORMANCE_BY_ADVISER_SCORES = 'performance-by-adviser-scores'
export const QUERY_KEY_QUESTIONS_LIST = 'questions-list-for-filter'
export const LOCAL_STORAGE_KEY_SERVICE_TYPE_FILTER = 'service-type-filter'
export const LOCAL_STORAGE_KEY_ARTICLE_AUTO_SAVE = 'article-auto-save-enabled'

export const QUERY_KEY_ADVISERS_TYPE = 'advisers'
export const QUERY_KEY_ADVISER_TYPE = 'adviser'
export const QUERY_KEY_AWARDS_TYPE = 'awards'
export const QUERY_KEY_QUALIFICATIONS_TYPE = 'qualifications'
export const QUERY_KEY_ADVISER_SETTINGS_DISCLAIMER_TYPE = 'advisers-settings-disclaimer'

export const QUERY_KEY_PROSPECT_CONVERSION_RANK = 'prospect-conversion-rank'
export const QUERY_KEY_ENQUIRY_PROFESSIONALS_FOR_FILTER = 'enquiry-professionals-for-filter'
export const QUERY_KEY_ENQUIRIES = 'enquiries';
export const QUERY_KEY_ENQUIRY = 'enquiry';
export const QUERY_KEY_NETWORK_PERFORMANCE_DATA_BY_FIRM = 'network-performance-data-by-firm'

export const QUERY_KEY_NETWORK_PERFORMANCE_OVER_TIME_DATA = 'network-performance-data-over-time'

export const QUERY_KEY_ARTICLES = 'articles'
export const QUERY_KEY_ARTICLE = 'article'
export const QUERY_KEY_ARTICLE_TAGS = 'article-tags'

export const QUERY_KEY_REVIEW_DATA = 'review-data';
export const QUERY_KEY_FREE_TEXT_ANALYSIS = 'free-text-analysis';
export const QUERY_KEY_RISK_SETTINGS_FETCH = 'risk-settings-fetch';
export const QUERY_KEY_OPPORTUNITY_SETTINGS_FETCH = 'opportunity-settings-fetch';
export const QUERY_KEY_TOP_RATED_ADVISERS_TYPE = 'top-rated-advisers'
export const QUERY_KEY_VERIFIED_ADVISERS_NUMBER = 'nr-of-verified-advisers'
export const QUERY_KEY_TOP_RATED_SCORE_FOR_CURRENT_YEAR = 'top-rated-score-for-current-year'
export const QUERY_KEY_TOP_RATED_SCORE_FOR_LAST_YEAR = 'top-rated-score-for-last-year'
export const QUERY_KEY_CLIENT_ACTIONS_REPORT = 'client-actions-report';
export const QUERY_KEY_REPORT_RISKS_OR_OPPORTUNITIES = 'report-risks-or-opportunities';

export const QUERY_KEY_FIRM_PROFILE = 'firm-profile';
export const QUERY_KEY_ALLOW_ADVISER_ARTICLES_CREATION = 'allow-adviser-articles-creation';
export const QUERY_KEY_FIRM_AWARDS_TYPE = 'firm-awards'
export const QUERY_KEY_FIRM_ACCREDITATIONS_TYPE = 'firm-accreditations'
export const QUERY_KEY_ACCREDITATIONS_TYPE = 'accreditations'
export const QUERY_KEY_REVIEW = 'review';
export const QUERY_KEY_FIRST_IMPRESSION = 'first-impression';
export const QUERY_KEY_UPDATE_RISK_AND_OPPORTUNITY = 'update-risk-and-opportunity';
export const QUERY_KEY_ADD_LICENCE_TYPE = 'add-licence'
export const QUERY_KEY_TOP_RATED_STATUS_FIRM_LIST = 'top-rated-status-firm-list'
export const QUERY_KEY_BULK_INVITE = 'get-bulk-invite';
export const QUERY_KEY_BULK_INVITE_STATS = 'get-bulk-invite-stats';
export const QUERY_KEY_BULK_INVITE_TEMPLATE = 'get-bulk-invite';
export const QUERY_KEY_BULK_INVITE_RECORDS = 'get-bulk-invite-records';
export const QUERY_KEY_ACTIVE_PROFESSIONALS = 'active-professionals';
export const QUERY_KEY_ACTIVE_PROFESSIONALS_FOLLOW_UP = 'active-professionals-follow-up';
export const QUERY_KEY_ADVISER_EMAIL_SIGNATURES = 'adviser-email-signatures'
export const QUERY_KEY_ADVISER_CERTIFICATES = 'adviser-certificates'
export const QUERY_KEY_INVITE_HISTORY = 'invite-history';
export const QUERY_KEY_INVITE_REQUESTS = 'invite-requests'
export const QUERY_KEY_REPORTING_HISTORY = 'reporting-history'
export const QUERY_KEY_REPORT_STATUS = 'report-status'
export const QUERY_KEY_SHORT_REVIEW_SETTING = 'short-review-setting'
